<template>
  <div>
    <!--单选框-->
    <el-radio-group
      :disabled="disable"
      v-model="value"
      v-if="config.rules.selectConfig.type == 'radio'"
    >
      <el-radio
        :label="item"
        v-for="(item, index) in config.rules.selectConfig.value.split('/')"
        :key="index + config.enName"
        @click.native.prevent="resetRadio(item)"
        >{{ item }}</el-radio
      >
    </el-radio-group>
    <!--多选框-->
    <el-checkbox-group
      :disabled="disable"
      v-model="value"
      v-else-if="config.rules.selectConfig.type == 'multi'"
    >
      <el-checkbox
        :label="item"
        v-for="(item, index) in config.rules.selectConfig.value.split('/')"
        :key="index + config.enName"
      ></el-checkbox>
    </el-checkbox-group>
    <!--单选下拉-->
    <el-select
      :disabled="disable"
      filterable
      clearable
      v-model="value"
      :placeholder="'请选择' + config.cnName"
      v-else-if="config.rules.selectConfig.type == 'radioSelect'"
    >
      <el-option
        v-for="(item, index) in config.rules.selectConfig.value.split('/')"
        :key="index + config.enName"
        :label="item"
        :value="item"
      >
      </el-option>
    </el-select>
    <!--多选下拉-->
    <el-select
      :disabled="disable"
      style="width: 100%"
      filterable
      multiple
      clearable
      v-model="value"
      :placeholder="'请选择' + config.cnName"
      v-else-if="config.rules.selectConfig.type == 'multiSelect'"
    >
      <el-option
        v-for="(item, index) in config.rules.selectConfig.value.split('/')"
        :key="index + config.enName"
        :label="item"
        :value="item"
      >
      </el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  props: ["data", "config", "disable"],
  computed: {
    value: {
      get() {
        return this.data;
      },
      set(val) {
        this.$emit("update:data", val);
      },
    },
  },
  methods: {
    resetRadio(val) {
      this.value = this.value == val ? "" : val;
      return;
    },
  },
};
</script>
